const HTTP_URL = process.env.REACT_APP_HTTP_URL ?? '';
export const serverOrigin = HTTP_URL.replace(/\/graphql\/?$/, '');
export const API_BASE = `${serverOrigin}/proxy/api`;

export const endpoints = {
    cfdi: {
        findBy: (authToken: string, startMs: number, endMs: number, query?: string) =>
            `${API_BASE}/v1/cfdi/findBy/${authToken}/${startMs}/${endMs}${query ? `?${query}` : ''}`,
        find: (authToken: string, search: string) =>
            `${API_BASE}/v1/cfdi/find/${authToken}/${search}`,
        status: (authToken: string, uuid: string) =>
            `${API_BASE}/v1/cfdi/status/${authToken}/${uuid}`,
        downloadXml: (authToken: string, uuid: string) =>
            `${API_BASE}/v1/cfdi/download/xml/${authToken}?uuid=${uuid}`,
        downloadPdf: (authToken: string, uuid: string) =>
            `${API_BASE}/v1/cfdi/download/pdf/${authToken}?uuid=${uuid}`,
        downloadPaymentXml: (authToken: string, uuid: string) =>
            `${API_BASE}/v1/payments/download/xml/${authToken}?uuid=${uuid}`,
        downloadPaymentPdf: (authToken: string, uuid: string) =>
            `${API_BASE}/v1/payments/download/pdf/${authToken}?uuid=${uuid}`,
    },
    sat: {
        productosServicios: (authToken: string) =>
            `${API_BASE}/v1/sat/productosServicios/${authToken}`,
        claveUnidades: (authToken: string) =>
            `${API_BASE}/v1/sat/claveUnidades/${authToken}`,
        usoCfdi: (authToken: string) =>
            `${API_BASE}/v1/sat/usoCfdi/${authToken}`,
        payTypes: (authToken: string) =>
            `${API_BASE}/v1/sat/payTypes/${authToken}`,
    },
    uploads: {
        cer: (authToken: string) => `${API_BASE}/v1/upload/cer/${authToken}`,
        key: (authToken: string) => `${API_BASE}/v1/upload/key/${authToken}`,
        logo: (authToken: string, extension: string) =>
            `${API_BASE}/v1/clients/logo/${authToken}?extension=${extension}`,
    },
};
